import PropTypes from 'prop-types';
import { Box, Stack, Typography, Switch } from '@mui/material';
import { formRowStyle } from 'src/styles/SettingsMenuStyle';

export default function SettingsToggleRow({ label, description, checked, onChange, disabled }) {
  return (
    <Box sx={formRowStyle}>
      <Stack spacing={0.25}>
        <Typography variant="body2" fontWeight={500}>
          {label}
        </Typography>
        {description && (
          <Typography variant="caption" color="text.secondary">
            {description}
          </Typography>
        )}
      </Stack>
      <Switch checked={checked} onChange={onChange} disabled={disabled} />
    </Box>
  );
}

SettingsToggleRow.propTypes = {
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

SettingsToggleRow.defaultProps = {
  description: '',
  checked: false,
  onChange: undefined,
  disabled: false,
};
